function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Modules");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.73
}, React.createElement("g", {
  id: "icon-module",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M14.5,0 L1.5,0 C0.673,0 0,0.673 0,1.5 L0,14.5 C0,15.327 0.673,16 1.5,16 L14.5,16 C15.327,16 16,15.327 16,14.5 L16,1.5 C16,0.673 15.327,0 14.5,0 Z M15,14.5 C15,14.776 14.776,15 14.5,15 L1.5,15 C1.224,15 1,14.776 1,14.5 L1,1.5 C1,1.2245 1.224,1 1.5,1 L14.5,1 C14.776,1 15,1.2245 15,1.5 L15,14.5 Z M3,5 L3,3 L13,3 L13.0005,5 L3,5 Z M3,13 L3,8 L5.46092323,8 L5.46153846,13 L3,13 Z M6.84665385,13 L6.84665385,8 L12.9998847,8 L13.0005,13 L6.84665385,13 Z",
  id: "Shape"
})));

const SvgModule = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgModule, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/module.d463c17b.svg";
export { ForwardRef as ReactComponent };